export default __webpack_public_path__ + "static/media/gallery-wip-handle-disc_07.fcc30b9f.jpg";